
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
	helperText: {
		marginTop: 8,
		paddingLeft: 12,
		fontSize: "12px",
	},
	errorField: {
    backgroundColor: theme.palette.background200,
    color: theme.palette.feedbackError100,
		paddingTop: 6,
		paddingLeft: 12,
		fontSize: "12px"
  },
}));

export default useStyles;
